import { createFileRoute } from "@tanstack/react-router";
import { WorkflowBoardsPage } from "@/pages/workflow-boards/ui/workflow-boards-page";
import { preloadWorkflowBoardsQueries } from "@/pages/workflow-boards/api/preload-workflow-boards-queries";
import { searchParams } from "@/pages/workflow-boards/model/search-params";

export const Route = createFileRoute("/_authed/$companySlug/workflows/")({
  component: WorkflowBoardsPage,
  loader: async ({ params }) => {
    void preloadWorkflowBoardsQueries(params.companySlug);
  },
  validateSearch: searchParams,
});
